import { MedicalInformationCountByType } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { MedicalDataIcon, SidePanelList } from '@dreryk/react-components';

import { medicalDataTranslationKeys } from '../../translations';

import { useCreateMedicalDataListItems } from './MedicalDataCategoriesSidePanelList.hooks';

type MedicalDataCategoriesSidePanelListProps = {
   readonly medicalData: MedicalInformationCountByType[] | undefined;
   readonly onItemHeaderClick: (item: MedicalInformationCountByType | undefined) => void;
};

export const MedicalDataCategoriesSidePanelList = (props: MedicalDataCategoriesSidePanelListProps): JSX.Element => {
   return (
      <SidePanelList
         icon={<MedicalDataIcon />}
         items={useCreateMedicalDataListItems(props.medicalData, props.onItemHeaderClick)}
         noItemsMessage={medicalDataTranslationKeys.noMedicalData}
      />
   );
};
